/* Shared pieces for the DreamCloud page's drill-downs: rows that open under a
 * problem or a job when it is tapped.
 *
 *   useDrilldown()  one open drill-down at a time; the latest request wins, and
 *                   closing one means an answer still on its way is dropped
 *                   rather than written onto a detail nobody is looking at.
 *   DcRunTable      a job's run history (dc_job_runs rows) as a table.
 */
import * as Vue from 'vue';
import { runState, runSummary, formatWhen } from '../rules/dreamcloud.js';

function useDrilldown() {
  var state = Vue.reactive({ key: null, type: null, rows: null, loading: false, error: null });
  var asked = 0;

  function close() {
    asked++;
    Object.assign(state, { key: null, type: null, rows: null, loading: false, error: null });
  }

  /* Opens `key` with what `fetch()` resolves to (an array), or closes it if it
   * is the one already open. `type` says which table the caller draws. */
  async function toggle(key, type, fetch) {
    if (state.key === key) { close(); return; }
    var mine = ++asked;
    Object.assign(state, { key: key, type: type || null, rows: null, loading: true, error: null });
    try {
      var rows = await fetch();
      if (mine !== asked) return;
      state.rows = Array.isArray(rows) ? rows : [];
    } catch (err) {
      if (mine !== asked) return;
      state.error = err.said || err.message || 'That did not load.';
    } finally {
      if (mine === asked) state.loading = false;
    }
  }

  return { state: state, toggle: toggle, close: close };
}

var DcRunTable = {
  name: 'DcRunTable',
  props: { runs: { type: Array, required: true } },
  setup: function () {
    return { runState: runState, runSummary: runSummary, when: formatWhen };
  },
  template: [
    '<table class="dc-table">',
    '  <thead><tr><th>Started</th><th>Run</th><th>Result</th></tr></thead>',
    '  <tbody><tr v-for="r in runs" :key="r.id">',
    '    <td><span class="dc-dot" :class="\'is-\' + runState(r)"></span>{{ when(r.started_at) }}</td>',
    '    <td>{{ r.trigger }}</td><td class="dc-table__wrap">{{ runSummary(r) }}</td>',
    '  </tr></tbody>',
    '</table>'
  ].join('\n')
};

export { useDrilldown, DcRunTable };
